import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, {useState} from "react"
import logo from "../images/go-logo.png"

const Header = ({ siteTitle }) => {
  const [active, setActive] = useState(false);

  const handleClick = () => { setActive(!active) }

  return (<nav class="navbar is-dark">
      <div class="navbar-brand">
          <a class="navbar-item" href="/">
              <img src={logo} alt="Logo" width="112" height="28" />
          </a>
          <Link
            onClick={handleClick}
            active={active}
            role="button"
            className={active
            ? "navbar-burger burger is-active"
            : "navbar-burger burger"}
            aria-label="menu"
            aria-expanded="false"
            data-target="navbarExampleTransparentExample">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </Link>
      </div>


      <div
          onClick={handleClick}
          active={active}
          className={active
          ? "navbar-menu is-active"
          : "navbar-menu"}>
          <div class="navbar-start">
              <Link className="navbar-item" to="/">Home</Link>
              <Link className="navbar-item" to="/profile">Profile</Link>
          </div>
      </div>
  </nav>)
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
